import { render, staticRenderFns } from "./ContabilitaSoggettoEditComponent.vue?vue&type=template&id=94fefe96&scoped=true"
import script from "./ContabilitaSoggettoEditComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaSoggettoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fefe96",
  null
  
)

export default component.exports